<template>
  <div>
    <v-row no-gutters class="mb-8 px-8">
      <v-col
        xs="0"
        sm="0"
        md="0"
        lg="1"
        xl="1"
        >
      </v-col>
        
      <v-col
        xs="12"
        sm="12"
        md="12"
        lg="10"
        xl="10"
        class="pt-8 d-flex flex-column"
      >
       <v-row class="d-flex align-center justify-center pb-2 mb-4">
        <v-col cols="12" class="text-center">
          <div class="text-h3 font-weight-light">
            {{ $t('title.setup') }}
          </div>
        </v-col>
      </v-row>

      <v-card flat class="pa-4 mb-4" style="background-color: #191919">
        <v-row>
          <v-col cols="12" sm="" class="ma-1" style="background-color: #202020;">
            <div class="mb-2">
              <div class="text-caption font-weight-bold">Razão Social</div>
              <div>{{ userInfo.company || 'Razão Social' }}</div>
            </div>
            <div class="mb-2">
              <div class="text-caption font-weight-bold">CNPJ</div>
              <div>{{ userInfo.cnpj || 'CNPJ' }}</div>
            </div>
          </v-col>

          <v-col cols="12" sm="" class="ma-1" style="background-color: #202020;">
            <div class="mb-2">
              <div class="text-caption font-weight-bold">Nome</div>
              <div>{{ userInfo.fullName || 'Nome Completo' }}</div>
            </div>
            <div class="mb-2">
              <div class="text-caption font-weight-bold">Telefone</div>
              <div >{{ userInfo.phone || 'Telefone' }}</div>
            </div>
            <div>
              <div class="text-caption font-weight-bold">E-mail comercial</div>
              <div style="text-decoration: underline;">{{ userInfo.email || 'E-mail Comercial' }}</div>
            </div>
          </v-col>
  
          <v-col cols="12" sm="" class="ma-1" style="background-color: #202020;">
            <div>
              <div class="text-caption font-weight-bold">Região</div>
              <div>{{ userInfo.region || 'Região' }}</div>
            </div>
          </v-col>
        </v-row>
      </v-card>

        <v-card outlined style="background-color: #121212;" class="mb-4">
          <div class="d-flex flex-column mx-4 my-4">
            <span class="text-h5 font-weight-light">
              Select up to four liquidity providers and set your USD limit for each: 
            </span>
            <v-data-table
              :headers="settingsHeaders"
              :items="bankList"
              item-key="name"
              :items-per-page="20"
              hide-default-footer
              class="mt-8 no-hover"
              style="max-height: 1000px; overflow-y: auto; background-color: #121212;"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item.name"
                    :style="{
                      backgroundColor: item.selected ? '#2a2a2a' : '#121212'
                    }"
                  >
                    <td class="text-center">
                      <v-checkbox
                        v-model="item.selected"
                        hide-details
                        dense
                        :disabled="!item.selected && selectedCount >= 4"
                        @change="saveSelectedBanks(item.name, item.selected)"
                      />
                    </td>
                    <td class="text-center">
                      <v-text-field
                        v-model="item.limit"
                        hide-details
                        dense
                        solo
                        flat
                        type="number"
                        class="my-2 remove-spin centered-input"
                        @input="saveLimit(item.name, item.limit)"
                      />
                    </td>
                    <td class="text-center">{{ item.name }}</td>
                    <td class="text-center">
                      <span 
                        :style="{
                          color: item.selected ? '#00E676' : '#ED2B2A',
                          fontWeight: 'bold',
                          textTransform: 'uppercase'
                        }"
                      >
                        {{ item.selected ? 'ON' : 'OFF' }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>

            <div class="mt-4 pa-4">
              <div class="text-h6 mb-4">Select Timezone</div>
              <v-radio-group v-model="timezoneLocal" @change="setTimezone">
                <v-radio label="UTC" value="UTC"></v-radio>
                <v-radio label="BRT" value="BRT"></v-radio>
              </v-radio-group>
            </div>
          </div>

        </v-card>
      </v-col>

      <v-col
        xs="0"
        sm="0"
        md="0"
        lg="1"
        xl="1"
      >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions  } from "pinia"
import { useExecutionStore, useSettingsStore } from "./../store/index"

export default {
  data () {
    return {
      settingsHeaders: [
        { text: "", value: "selected", align: "center", sortable: false, width: "10%" },
        { text: "Limit", value: "limit", align: "center", sortable: false, width: "30%" },
        { text: "bank", value: "name", align: "center", sortable: false, width: "30%" },
        { text: "Connection status", value: "status", align: "center", sortable: false, width: "30%" }
      ],
      bankList: [],
      userInfo: {
        company: "",
        cnpj: "",
        fullName: "",
        phone: "",
        email: "",
        region: "",
      },
      timezoneLocal: useSettingsStore().timezone,
      focusState: {},
      brokerId: null,
      companyId: null,
      client: null
    }
  },
  mounted() {
    if (this.isMockDataOn) {
      this.companyId = localStorage.getItem('companyId')
      this.brokerId = localStorage.getItem('brokerId')
      this.userInfo = {
        company: "ACME LTDA",
        cnpj: "12.345.678/0001-90",
        fullName: "João Brasileiro",
        phone: "(11) 99999-9999",
        email: "joao@acme.com",
        region: "Sudeste",
      }
      this.fetchClientInfo().then(() => {
        this.fetchMockBanks()
      })
    }
    // this.bankList.forEach(bank => {
    //   const bankName = bank.name.replace(/\s+/g, '')

    //   const savedLimit = localStorage.getItem(`limit${bankName}`)
    //   if (savedLimit !== null) {
    //     bank.limit = Number(savedLimit)
    //   }

    //   const savedSelected = localStorage.getItem(`selected${bankName}`)
    //   if (savedSelected !== null) {
    //     bank.selected = JSON.parse(savedSelected)
    //   }
    // })
  },
  computed: {
    ...mapState(useSettingsStore, [
      "isMockDataOn"
    ]),
    selectedCount() {
      return this.bankList.filter(inst => inst.selected).length
    }
  },
  methods: {
    ...mapActions(useExecutionStore, [
      'getMockBanks',
      'getBrokerClients',
      'saveBrokerClients'
    ]),
    ...mapActions(useSettingsStore, [
      'setTimezone'
    ]),
    fetchClientInfo () {
      return this.getBrokerClients(this.brokerId)
        .then(response => {
          const clients = response.data.clients || []
          this.client = clients.find(c => c.id === this.companyId)

          if (!this.client) {
            console.warn("Client not found for this broker.")
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchMockBanks () {
      this.getMockBanks()
        .then(response => {
          const banks = response.data.banks.map(b => ({
            name: b.name,
            selected: false,
            limit: 100000
          }))

          const selected = this.client?.bankList || []

          banks.forEach(bank => {
            if (selected.includes(bank.name)) {
              bank.selected = true
            }
          })

          this.bankList = banks
          if (selected.length > 0) {
            selected.forEach(bankName => {
              this.saveSelectedBanks(bankName, true)
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    saveSelectedBanks (name, selected) {
      const bank = this.bankList.find(inst => inst.name === name)
      if (bank) {
        bank.connected = selected ? "ON" : "OFF"
      }

      const selectedBanks = this.bankList
        .filter(bank => bank.selected)
        .map(bank => bank.name)

      if (!this.client || !this.companyId || !this.brokerId) return

      // Update the current client object
      this.client.bankList = selectedBanks

      // Step 1: fetch the broker's full client list from the API
      this.getBrokerClients(this.brokerId)
        .then(response => {
          const clients = response.data.clients || []

          // Step 2: replace only the matching client in that list
          const updatedClients = clients.map(c =>
            c.id === this.companyId ? this.client : c
          )

          // Step 3: send the updated list to the API
          this.saveBrokerClients(updatedClients, this.brokerId)
            .catch(err => {
              console.error("Failed to save updated clients list", err)
            })

          // Optionally also write to localStorage for quoting use
          localStorage.setItem(
            `selectedBankNames_${this.client.id}`,
            JSON.stringify(selectedBanks)
          )
        })
        .catch(error => {
          console.error("Failed to fetch broker client list", error)
        })
    },
    saveLimit(name, limit) {
      const bankName = `limit${name.replace(/\s+/g, '')}`
      localStorage.setItem(bankName, limit)
    },
  }
}
</script>

<style scoped>
.no-hover tr:hover:not {
  background-color: unset !important;
}

.centered-input >>> input {
  text-align: center
}
.remove-spin >>> input[type="number"] {
  -webkit-appearance: none; /* Chrome, Safari, Edge */
  -moz-appearance: textfield; /* Firefox */
  appearance: textfield; /* Outros navegadores */
}

.remove-spin >>> input[type="number"]::-webkit-inner-spin-button,
.remove-spin >>> input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>